// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  lobbyId: __t.string().primaryKey().name("lobby_id"),
  timerScheduledAt: __t.option(__t.timestamp()).name("timer_scheduled_at"),
  createdAt: __t.timestamp().name("created_at"),
  matchId: __t.option(__t.string()).name("match_id"),
});
